import API from '@/services/api'
import getPointIdFromStorage from '@/services/getPointId'

export default async function getCustomerPlans(pointId) {
  try {
    if (!pointId) {
      pointId = getPointIdFromStorage().id
    }
    const response = await API.get(`plans?point_id=${pointId}`)

    if (response.data) {
      return response.data
    }
    return
  } catch (error) {
    console.log(error)
  }
}
